
import { Component, Vue } from 'vue-property-decorator'
import { Pagination } from '@/components/common/organisms/PaginationButton.vue'

export type HistoryByStudentData = {
  studentName: string
  pagination: Pagination
  responses: HistoryData[]
}

export type HistoryData = {
  resultDrillsId: number
  studyName: string
  studiedAt: string // テスト毎の最新の完了日
}

@Component
export default class HistoryByStudentApis extends Vue {
  /**
   * 受験履歴取得
   */
  protected async getHistoryByStudent(Page: number, bcbtCode: string): Promise<HistoryByStudentData> {
    const { data } = await Vue.prototype.$http.httpWithToken.get(
      `v1/branch/history_by_student/${bcbtCode}?page=${Page}`
    )
    return data
  }
}
